import {
  FilterValue,
  SelectGroup,
  SelectItem,
  SelectOption,
  SelectOptionPeriod,
  SelectOptionString,
  SelectOptionStringArray,
} from "../../types/filter";
import { isStringArrayFilterValue, stringArrayAreTheSame } from "./filtervalue";

export function isSelectGroup(option: SelectItem): option is SelectGroup {
  return "options" in option;
}

export function isSelectOption(option: SelectItem): option is SelectOption {
  return "value" in option;
}

export function isCustomPeriodOption(
  option: SelectItem
): option is SelectOptionPeriod {
  return "startDate" in option && "endDate" in option;
}

function isSelectOptionString(
  option: SelectItem
): option is SelectOptionString {
  return "value" in option && typeof option.value === "string";
}

export function isSelectOptionStringArray(
  option: SelectItem
): option is SelectOptionStringArray {
  return "value" in option && Array.isArray(option.value);
}

export function getSelectOptionKey(
  prefix: string | number,
  option: SelectItem
) {
  if (isSelectOptionStringArray(option)) {
    return `${prefix}-${option.value.join("-")}`;
  } else if (isSelectOptionString(option)) {
    return `${prefix}-${option.value}`;
  } else {
    return `${prefix}-${option.title}`;
  }
}

export function isSelectOptionSelected(
  selected: FilterValue,
  option: SelectOption
) {
  if (isStringArrayFilterValue(selected)) {
    if (isSelectOptionStringArray(option)) {
      return stringArrayAreTheSame(selected.value, option.value);
    } else {
      return selected.value.includes(option.value);
    }
  } else {
    return selected.value === option.value;
  }
}
